module.exports = "<button class=\"btn btn-sm\"\n [ngClass]=\"{ 'disabled' : isSubmitting,\n              'btn-outline-primary': !article.favorited,\n              'btn-primary': article.favorited }\"\n (click)=\"toggleFavorite()\">\n  <i class=\"ion-heart\"></i> <ng-content></ng-content>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/buttons/favorite-button.component.html
// module id = ./src/app/shared/buttons/favorite-button.component.html
// module chunks = main